// extracted by mini-css-extract-plugin
export default {"pluginPage":"PluginPage_pluginPage__7b-cr"};